"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/InboxTabs.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Chips = require('web/components/Chips'); var _Chips2 = _interopRequireDefault(_Chips);
var _icons = require('./icons');








/* The inbox tabs (one at a time), each with its count. They filter on the
 * server, and apply inside Archived too. With only one tab left there is
 * nothing to pick, so the row goes. */
const InboxTabs = ({ pills, activeTab, onSelectTab }) => {
  if (pills.length <= 1) return null
  return (
    _react2.default.createElement('div', { className: "inbox-tabs", role: "group", 'aria-label': "Filter chats" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
      , _react2.default.createElement(_Chips2.default, { pills: pills, activeTab: activeTab, onSelectTab: onSelectTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}} )
    )
  )
}






/* The archive toggle, beside the search field, so it never takes a tab's
 * room or wraps with them. */
 const ArchiveToggle = _react.memo.call(void 0, ({ isArchived, onToggleArchived }) => (
  _react2.default.createElement('button', {
    type: "button",
    className: _classBuilder2.default.call(void 0, 'inbox-list--archive', isArchived && 'is-on'),
    'aria-label': "Archived",
    'aria-pressed': isArchived,
    title: "Show archived" ,
    onClick: onToggleArchived, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}

    , _react2.default.createElement(_icons.ArchiveIcon, { size: 18, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} )
  )
)); exports.ArchiveToggle = ArchiveToggle

exports. default = _react.memo.call(void 0, InboxTabs)
